<div class="header-wrapper container">
  <div class="row justify-content-center mt-4 mb-4">
    <div class="col-6">
      <img src="/assets/images/epione-net-logo-white.png"
           class="img-fluid mx-auto d-block integration-logo"
           alt="Epione.net logo">
    </div>
  </div>
  <div class="content-wrapper">
    <ng-content></ng-content>
  </div>
</div>